import React from "react"
import { Button, Form, Container, Row, Col, Fade } from "react-bootstrap";
import Select from "react-dropdown-select"
import algoliasearch from "algoliasearch/lite"
import { Link } from "gatsby"
import isbot from 'isbot'
import axios from 'axios';

import { navigate } from "@reach/router"
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import FilterBlock from "../Components/SearchResult/FilterBlock/FilterBlock";
import SeoResults, { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "../Components/property-search/seoResults"
import { parseSearchUrl, propertyH1, propertyDesc, getBranchPostcode } from "../Components/property-search/utils";
import NoResultList from "../Components/SearchResult/SearchList/NoResultList";
import SearchList from "../Components/SearchResult/SearchList/SearchList";

import LoadmorePagination from "../Components/SearchResult/SearchList/LoadmorePagination"
import LoadpreviousPagination from "../Components/SearchResult/SearchList/LoadpreviousPagination"

import { UserObjectStoreProvider, SaveItem, getUserobjectData, isAuthenticated, savedSearchParams } from "@starberry/myaccount-website-utils";

//const { parseResultsUrl, generateFiltersfromPageData } = require("@starberry/gatsby-library-common/PropertySearchNew")
const { parseResultsUrl, generateFiltersfromPageData } = require("../gatsby-library-common/PropertySearchNew")


// 
var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""

var includeSold = false;

const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`

const defaultArea = {
  name: "Essex and Kent",
  slug: "essex-and-kent"
}

const sort_by_options = [
  {
    value: index_name ,
    label: "Most recent",
  },
  {
    value: index_name + "_price_desc",
    label: "Highest Price",
  },
  {
    value: index_name + "_price_asc",
    label: "Lowest Price",
  },
]
// 

class PropertySearch extends React.Component {

    isUserInteraction = true;

    constructor(props) {
        super(props);
    }
    
    /* ========= Local Cache =========== */
    local_storage_data = typeof window !== 'undefined' &&  localStorage.getItem('algolia_data') ? JSON.parse(localStorage.getItem('algolia_data')) : [];

    // 
    state = {
        //searchState: urlToSearchState(typeof window !== 'undefined' ? window.location : ''),
        userObjects: {},
        includeSoldinside: false,
        includeLetinside: false,
        areaVal:"",
        algoliadata: [],
        my_page_url_data: [],
        local_cache: this.local_storage_data  // ========= Local Cache ===========  
    }

    componentDidMount() {
      window.addEventListener('popstate', this.onPopState);
      //this.getAlgoliaResults();
      this.checkGoogleBot();  

      if(isAuthenticated){
        const getUserObjects = async () => {
          try {
              const userObjects = await getUserobjectData()
              this.setState({
                userObjects : userObjects.data.data
              })
              console.log("success");
          } catch (e) {
              console.log("e:", e)
          }
        }
        getUserObjects()
      }
    }

    componentWillUnmount() {
      //clearTimeout(this.debouncedSetState);
      window.removeEventListener('popstate', this.onPopState);
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
          //this.setState({ searchState: urlToSearchState(this.props.location) })
          this.isUserInteraction = true;

          //this.getAlgoliaResults();
          this.checkGoogleBot();
          
        }
    }

    // 
    includeSoldclick = e => {
      // this.setState({
      //   includeSoldinside: !this.state.includeSoldinside
      // })
      this.setState({includeSoldinside: !this.state.includeSoldinside}, () => {
        this.isUserInteraction = true 
        this.getAlgoliaResults()
      })
    }
  
    includeLetclick = e => {
      // this.setState({
      //   includeLetinside: !this.state.includeLetinside
      // })
      this.setState({includeLetinside: !this.state.includeLetinside}, () => {
        this.isUserInteraction = true 
        this.getAlgoliaResults()
      })
    }

    // List View
    listView = (e) => {
      // navigate("/properties/"+this.props.ptypetag+"/in-essex")
      if(this.props.pcategorytype === "new_developments") {
        navigate(this.props.location.pathname.replace("new-homes-map/", "new-homes-"))  
      } else {
        navigate(this.props.location.pathname.replace("properties-map/", "properties-"))
      }
    }
    // List View

    // Map View
    mapView = (e) => {
        // navigate("/properties-map/"+this.props.ptypetag+"/in-essex")
        if(this.props.pcategorytype === "new_developments") {
          navigate(this.props.location.pathname.replace("new-homes-", "new-homes-map/"))  
        } else {
          navigate(this.props.location.pathname.replace("properties-", "properties-map/"))
        }
    }
    // Map View

    onPopState = ({ state }) => {
      this.setState({
          searchState: state || {},
      });
    }



    checkGoogleBot = () =>{
      let realuser = true
      if (typeof window !== 'undefined') {
          realuser = (process.env.GATSBY_BLOCK_ALGOLIA_BOT_REQUEST === "true") ? (isbot(navigator.userAgent) ||  navigator.userAgent.indexOf("Prerender") > -1) : false
      }
      //console.log("realuser ==>", realuser)

      if(realuser === false){
          this.getAlgoliaResults();
      } else{
          this.getBotSearchResult();
      }
    }

    getBotSearchResult = async() => {
      let base_path = this.props.locationname   // property-for-sale, property-to-rent and etc..
      let search_type = this.props.ptype   // sales, lettings 
      let department_type = this.props.pcategorytype   // residential, commercial 
      let property_status = this.props.ptypetag   // for-sale, to-rent

      const page_url_data = parseResultsUrl(this.props.location, base_path, search_type, department_type, property_status, index_name)
      this.setState({ my_page_url_data: page_url_data })

      let $where = `_where[publish]=true&[department]=${this.props.pcategorytype}&[search_type]=${this.props.ptype}`

      let status_arr = this?.props?.pstatustype;
      if(Array.isArray(this?.props?.pstatustype)){
          if(status_arr.length > 0){
              status_arr.map((status, ind) => {
                  $where +=`&[_or][${ind}][status_contains]=${status}`
              })
          }
      } else{
          $where +=`&[status_contains]=${this?.props?.pstatustype}`
      }

      let sorting = `display_address:DESC,available_from:DESC,price:DESC,post_code:ASC`;

      let area_name = page_url_data['areaVal'];
      console.log("area_name", area_name, page_url_data)
      
      if(area_name === this.state.areaVal){
          $where +="";
      } else{
          $where +=`&[display_address_contains]=${area_name}`
      }

      if(page_url_data['buildingval']){
          $where += `&[building_contains]=${page_url_data['buildingval']}`;
      }
      if(page_url_data['bedVal']){
          $where += `&[bedroom_gte]=${page_url_data['bedVal']}`;
          sorting = `bedroom:ASC,display_address:DESC,available_from:DESC,price:DESC,post_code:ASC`;
      }
      if(page_url_data['bedVal'] === 0){
          $where += `&[bedroom_lte]=${page_url_data['bedVal']}`;
          sorting = `bedroom:ASC,display_address:DESC,available_from:DESC,price:DESC,post_code:ASC`;
      }

      const auth_headers = { Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`}
      const property_api_link = `${process.env.GATSBY_STRAPI_SRC}/properties`

      let count_properties = await axios.get(`${property_api_link}/count?_sort=${sorting}&${$where}`,{headers: auth_headers})

      //console.log("count_properties", count_properties, count_properties?.data)

      axios.get(`${property_api_link}?_limit=20&_sort=${sorting}&${$where}`, {headers: auth_headers}).then(res => {
          console.log("res =>1", res)
          if(res.status === 200){
              if(count_properties?.data > 0){
                  this.setState({
                      algoliadata: {hits:res.data, total: count_properties?.data, realuser: true}
                  })

                  this.isUserInteraction = false;
                  this.forceUpdate();
              } else{
                  this.getAlgoliaResults();
              }

          } else{
              this.getAlgoliaResults();
          }
      }).catch(err => {
        console.log("error_api", err)
      })

    }

    // Get Algolia Filter
    getAlgoliaResults = () => {
      let base_path = this.props.locationname   // property-for-sale, property-to-rent and etc..
      let search_type = this.props.ptype   // sales, lettings 
      let department_type = this.props.pcategorytype   // residential, commercial 
      let property_status = this.props.ptypetag   // for-sale, to-rent

      const page_url_data = parseResultsUrl(this.props.location, base_path, search_type, department_type, property_status, index_name) 


      if(page_url_data){
        this.setState({ my_page_url_data: page_url_data })
        const searchParams = parseSearchUrl(this.props?.ptype, this.props.fullpathname, this.props.pcategorytype);
        let myalgoliafilters = generateFiltersfromPageData(page_url_data['departmentVal'], page_url_data['searchtypeVal'], page_url_data['areaVal'], page_url_data['bedVal'], page_url_data['minpriceVal'], page_url_data['maxpriceVal'], page_url_data['buildingval'], page_url_data['mustincludeVal'], page_url_data['furnishVal'], page_url_data['branchVal'])

        let mystatus = '';
        let branchPostCode = getBranchPostcode(searchParams.areas); 
        var defaultStatus = this.state.includeSoldinside ? ["For Sale", 'Exchanged','Under Offer', "Sold"] : this.props.pstatustype;
        if (this.props.ptype === "lettings") {
          defaultStatus = this.state.includeLetinside ? ["To Let", "Let Agreed"] : this.props.pstatustype;
        }

        if(Array.isArray(defaultStatus)){
            mystatus = '(status:"'+(defaultStatus).join('" OR status:"')+'")'
        } else {
            mystatus = '(status:"'+(defaultStatus)+'")'
        }
        myalgoliafilters += ' AND '+mystatus
      
        if(branchPostCode){
          myalgoliafilters +=  ' AND '+'(post_code:"'+(branchPostCode).join('" OR post_code:"')+'")'
        }

        myalgoliafilters = myalgoliafilters.replace("(publish: true) AND", '')

        // console.log("page_url_data", myalgoliafilters);

        const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_API_KEY);
        const index = client.initIndex(page_url_data['sortVal'] ? page_url_data['sortVal'] : page_url_data['indexVal']);


        /* ========= Local Cache =========== */
        let path_name = typeof window !== 'undefined' ? window.location.href : ''
        var expTime = new Date().setMinutes(new Date().getMinutes() + 5);
        let filter_local_cache = this.filterLocalCache(path_name);

        if(filter_local_cache?.length > 0 && myalgoliafilters === filter_local_cache[0][path_name].filter_data){
            let get_data = filter_local_cache[0];
            let get_data_pathname = get_data[path_name]

            if(get_data_pathname?.total > 0){
                this.setState({
                    algoliadata: get_data_pathname
                })
            } else{
                this.setState({ algoliadata: [] })
            }

            this.isUserInteraction = false;
            
        } else{

          if (this.isUserInteraction) {

            // Filters declared here
            let filters = {
              filters: myalgoliafilters,
              page: (page_url_data['pageVal'] - 1),
              hitsPerPage: 12,
            }

          

            let area_name = ""
            if(branchPostCode === null){
              area_name = searchParams.areas.replace(/-/g, " ");
            }
            let areaVal = (searchParams.areas === (defaultArea.slug).toLowerCase() ? '' : area_name);



            index.search(areaVal, filters).then(({ nbHits, page, hitsPerPage, nbPages, hits }) => {
                
                /* ========= Local Cache expTime =========== */
                let myArray = { "total": nbHits, "current_page_number": page, "hitsPerPage": hitsPerPage, "number_of_pages": nbPages, "hits": hits, expTime: expTime, filter_data: myalgoliafilters };
                
                if(nbHits > 0){
                    this.setState({ algoliadata: myArray })
                    this.isUserInteraction = false;
                    this.forceUpdate();
                }
                else{
                    this.setState({ algoliadata: [] })
                    this.isUserInteraction = false;
                    this.forceUpdate();
                }

                /* ========= Local Cache =========== */
                this.setState({
                    local_cache: [...this.state.local_cache, {[path_name]: myArray}]
                    }, () => localStorage.setItem('algolia_data', JSON.stringify(this.state.local_cache))
                )

            });
          }

        }

      }
    }


  /* ========= Local Cache =========== */
  filterLocalCache = (path_name) => {
    let get_local_cache = this.state.local_cache;
    let filter_local_cache = [];

    if(get_local_cache?.length > 0){
        let remove_local_cache =  get_local_cache?.filter(key => Object.values(key)[0]?.expTime > (new Date().getTime()))

        this.setState({
            local_cache: remove_local_cache
            }, () => localStorage.setItem('algolia_data', JSON.stringify(remove_local_cache))
        )

        filter_local_cache = remove_local_cache?.length > 0 && remove_local_cache?.filter(key => key[path_name]);
    }

    return filter_local_cache;
  }

  //SortBy
  sortByChange = event => {
    //console.log("event =>", event)
    var sort_path = "";

    if(event.length > 0){
      if (event[0].value === index_name + "_price_asc") {
        sort_path = "sortby-price-asc/";
      } else if (event[0].value === index_name + "_price_desc") {
        sort_path = "sortby-price-desc/";
      } else {
        sort_path = "";
      }
    }

    var location_path_remove = this.props.fullpathname.replace('sortby-price-desc/', '').replace('sortby-price-asc/', '');
    var search_url = location_path_remove + sort_path
    navigate(search_url)
  }

  // Change area val
  areaValChange = (val) => {
    this.setState({
      areaVal: val
    })
  }



  render() {

    const capitalize = (s) => {
      if (typeof s !== 'string') return '';
      const lowerCaseWords = ['and', 'or', 'the', 'of'];
      return s
        .replace(/%20/g, ' ')
        .replace(/-/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => {
          // special spelling rule
          if (word === 'essex') return 'Essex';

          // keep conjunctions lowercase
          if (lowerCaseWords.includes(word)) return word;

          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    };

    const searchParams = parseSearchUrl(this.props?.ptype, this.props.fullpathname, this.props.pcategorytype);

    const saveSearchParams = savedSearchParams(searchParams);

    const h1 = propertyH1(searchParams);
    const h1desc = propertyDesc(searchParams);
    const areaName = searchParams.areas;
    const pType = searchParams.pType;

    let propertyType = "";
    if (searchParams.type == "") {
      propertyType = "property "
    } else {
      propertyType = searchParams.type
    }

      const actionStr = ACTION_TYPES[pType];
      const actionDescStr = ACTION_DESC_TYPES[pType];

      const isPageLoadBg = (typeof this.props.fullpathname === "undefined");
      var replaceH1 = capitalize(h1);//h1.replace(/-/g, ' ');
        //replaceH1 = replaceH1.replace("Essex", "Essex and Kent");
      var replaceh1SEC = h1desc.replace(/-/g, ' ');
        //replaceh1SEC = replaceh1SEC.replace("Essex", "Essex and Kent");
      var areaReplace = capitalize(areaName).replace("%20"," ")
        //areaReplace = areaReplace.replace("Essex", "Essex and Kent");

      let sortby_placeholder = searchParams.sortVal === "price-asc" ? "Lowest Price" : searchParams.sortVal === "price-desc" ? "Highest Price" : "Most Recent";

      //console.log("algoliadata =>", this.state.algoliadata?.hits, this.state.algoliadata?.total);

      return (
          <React.Fragment>
            <UserObjectStoreProvider>
              {!isPageLoadBg &&
                <SeoResults title={h1} searchParams={searchParams}  location={this.props.fullpathname} pcategorytype={this.props.pcategorytype} ptypetag={this.props?.ptypetag}/>
              }

              <div className="wrapper primary-icon-template">
                  <div className="inner-header"><Header /></div>

                  <FilterBlock searchParams={searchParams} type={this.props.ptype} department={this.props.pcategorytype} areaValChange={this.areaValChange}/>
                    
                  <div className={`search-list-block`}>
                        <Container>
                            <Row>
                                <Col md="12">
                                <div className="search-heading">
                                    <h1>{replaceH1}</h1>
                                    <div className="search-block-content d-md-flex align-items-lg-start">
                                      <p>Discover a wide range of {replaceh1SEC} with Balgores estate agents. To filter these results, use our filter above, or for more information about {pType} property in {areaReplace}, please <Link to="/branches">contact us</Link>.</p>
                                      <SaveItem  type="search" searchParams={saveSearchParams} userObjects={this.state.userObjects}>
                                        <div className="search-save">
                                            <i className="icon-heart"></i> <span>Save this search</span>
                                        </div>
                                      </SaveItem>
                                    </div>
                                </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <div className="property-view">
                                        <span className="search-number">{this.state.algoliadata?.total > 0 ? this.state.algoliadata?.total : 0} Properties</span>
                                        <div className="search-right">
                                            <div className="checkbox-block d-flex align-items-center">
                                            {this.props.ptype === "lettings" ?
                                              <div className="switch-button ">
                                                <label for="toggle-button">
                                                  <input onChange={this.includeLetclick}
                                                    type="checkbox" id="toggle-button"
                                                    checked={this.state.includeLetinside ? "checked" : ""} />
                                                  <span className="toggle-switch">
                                                    <span className="toggle-switch-bar"></span>
                                                  </span>
                                                  <span className="toggle-text">Include Let</span>
                                                </label>
                                              </div>
                                              :
                                              <div className="switch-button ">
                                                <label for="toggle-button">
                                                  <input onChange={this.includeSoldclick}
                                                    type="checkbox" id="toggle-button"
                                                    checked={this.state.includeSoldinside ? "checked" : ""} />
                                                  <span className="toggle-switch">
                                                    <span className="toggle-switch-bar"></span>
                                                  </span>
                                                  <span className="toggle-text">Include Sold</span>
                                                </label>
                                              </div>
                                            }
                                            </div>

                                            {/* <div className="checkbox-block">
                                                <Form.Group controlId="formBasicCheckbox">
                                                    <Form.Check type="checkbox" label="Include sold" />
                                                </Form.Group>
                                            </div> */}

                                            {/* <button type="button" className="list-view active" onClick={this.listView}>
                                                <i className="icon-list"></i>
                                                <span>List View</span>
                                            </button> */}

                                            {/* <button type="button" className="grid-view">
                                                <i className="icon-grid"></i>
                                            </button> */}

                                            {/* <button type="button" className="view-pin" onClick={this.mapView}>
                                                <i className="icon-pin"></i>
                                                <span>Map View</span>
                                            </button> */}

                                            <div className="recent-select">
                                              <div className="prices search-select-box">
                                                <Select
                                                  options={sort_by_options}
                                                  searchable="false"
                                                  placeholder={sortby_placeholder}
                                                  onChange={this.sortByChange}
                                                />
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        
                        {!this.isUserInteraction && 
                          (this.state.algoliadata?.total > 0 ?                          
                          <>
                            <Container>
                              <LoadpreviousPagination total={this.state.algoliadata.total} hitsPerPage={this.state.algoliadata.hitsPerPage} current_page_number={this.state.algoliadata.current_page_number} number_of_pages={this.state.number_of_pages} location_path={this.props.fullpathname} />
                            </Container>

                            <SearchList hits={this.state.algoliadata?.hits} tag={this.props.ptypetag}  noResult={false} userObjects={this.state.userObjects} />

                            {(this.state.algoliadata.total > this.state.algoliadata.hitsPerPage) && (this.state.algoliadata?.current_page_number + 1) !== this.state.algoliadata?.number_of_pages && (
                              <Container>
                                <LoadmorePagination total={this.state.algoliadata.total} hitsPerPage={this.state.algoliadata.hitsPerPage} current_page_number={this.state.algoliadata.current_page_number} number_of_pages={this.state.algoliadata.number_of_pages} location_path={this.props.fullpathname} />
                              </Container>
                            )}
                          </>
                          
                          :

                          <Row>
                            <Col lg={12} className="text-center no-properties-text mb-5">
                              <h4>Unfortunately, we do not currently have any properties that match your search criteria.</h4>              
                              <h4 className="noresul">We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</h4>
                            </Col>

                            <NoResultList ptype={this.props.ptype} status={(this.props.ptype === "lettings") ? "To Let" : "For Sale"} department={this.props.pcategorytype} />
                          </Row>
                          )                          
                        }
                  </div>

                  <Footer searchtype='results' searchParams={searchParams} />
              </div>
              </UserObjectStoreProvider>
          </React.Fragment>
      )
  }
}

export default PropertySearch
